module.exports = __webpack_public_path__ + "static/img/bg3.106c30f.png";